export const PageContentTitle = ({ title }: { title?: string }) =>
  title && (
    <div className="py-2 text-300 font-bold text-black-100">{title}</div>
  );
